import React, { useState } from 'react';
import Tab from '@mui/material/Tab';
import TabPanel, { a11yProps } from 'components/Common/TabPanel/TabPanel';
import StudentProfileTab from './StudentProfileTab';
import ScheduleTab from './ScheduleTab';
import ScoresTab from './scoresTab/ScoresTab';
import DashboardPasswordTab from './DashboardPasswordTab';
import { StickyTab, TabContainer } from 'components/Ui/styled';
import { usePermissionCustomHook } from 'layouts/users/userPermissions/utils/permissionsUtils';

const StudentProfileTabs = () => {
  const [value, setValue] = useState(0);

  const handleTabChange = (event, newValue) => {
    setValue(newValue);
  };

  const canAccessStudentTestingData = usePermissionCustomHook(
      'CAN_ACCESS_STUDENT_TESTING_DATA'
    );

  const studentProfileTabs = [
    { label: 'Student Profile', component: <StudentProfileTab /> },
    { label: 'Schedule', component: <ScheduleTab /> },
    ...(canAccessStudentTestingData
      ? [{ label: 'Testing Data', component: <ScoresTab /> }]
      : []),
    { label: 'Dashboard Password', component: <DashboardPasswordTab /> },
  ];

  return (
    <TabContainer>
      <StickyTab
        value={value}
        onChange={handleTabChange}
        aria-label="studentProfileTabs"
      >
        {studentProfileTabs?.map((tab, index) => (
          <Tab key={tab.label} label={tab.label} {...a11yProps(index)} />
        ))}
      </StickyTab>

      {studentProfileTabs?.map((tab, index) => (
        <TabPanel key={tab.label} value={value} index={index}>
          {tab.component}
        </TabPanel>
      ))}
    </TabContainer>
  );
};

export default StudentProfileTabs;
